import { BaseApi } from './base.api.js';

export class DocumentTypeApi extends BaseApi {
    constructor(client) {
        super(client, '/document-type');
    }
}
